<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-container>
        <el-main :style="`height:${dispH - 260}px;`" class="border-normal">
          <ImageBox
            :src="getImageURL(dispPhoto)"
            :width="dispW - 500"
            :height="dispH - 265"
            :focus="true"
            :colorHex="graphColor"
            :marking="getMarking()"
            :info="getInfo()"
            :proc="getProc()"
            :eyetype="getEyeType()"
            :currentUnit="graphUnit"
            :currentPhoto="dispPhoto"
            curPage="eyelidedge"
            @update="update"
            @focus="onImageFocus"
            @paper="selectPaper"
            :graphMode="graphMode"
          />
        </el-main>
        <el-footer>
          <el-row style="padding-top: 20px; display: flex; justify-content: flex-end">
            <div>
              <el-button
                class="btn-oprator border-recording retakeStyle"
                :style="`${isIT ? 'font-size:35px;' : 'font-size:40px'}`"
                @click="retake('up')"
                >{{ `${$t("langcfg.txtRetakeUpEyelidedge")}` }}</el-button
              >
            </div>
            <div style="margin-left: 50px">
              <el-button
                class="btn-oprator border-recording retakeStyle"
                :style="`${isIT ? 'font-size:35px;' : 'font-size:40px'}`"
                @click="retake('down')"
                >{{ `${$t("langcfg.txtRetakeDownEyelidedge")}` }}</el-button
              >
            </div>
            <div style="margin-left: 10px; display: flex; font-size: 30px">
              <span style="padding-right: 10px">{{ $t("langcfg.txtRemarks") }}:</span>
              <span>
                <el-input
                  v-model="note"
                  style="width: 350px; height: 80px"
                  resize="none"
                  :row="4"
                  @change="changeNote"
                  @click.native.stop.prevent="handleClick"
                  @touchend.native.stop.prevent="handleClick"
                  type="textarea"
                />
              </span>
            </div>
          </el-row>
        </el-footer>
      </el-container>
      <el-container>
        <el-aside
          width="100%"
          :style="`display:flex;flex-direction:column;align-items:center;height:${
            dispH - 210
          }px;padding-top:5px;padding-bottom:5px;padding-right:5px`"
        >
          <div class="border-top" :style="`width:380px;height:270px;display:flex;`">
            <ImageItem
              :id="0"
              :thumbnail="listImg.up.thumbnail"
              :currentid="currentid"
              @select="selectItem"
              :imagename="$t('langcfg.txtUpEyelidEdge')"
              :dispH="270"
            />
          </div>
          <split-h class="split-h" :splitH="5"></split-h>
          <div class="border-top" :style="`width:380px;height:270px;margin-top:7px;display:flex;`">
            <ImageItem
              :id="1"
              :currentid="currentid"
              :thumbnail="listImg.down.thumbnail"
              @select="selectItem"
              :imagename="$t('langcfg.txtDownEyelidEdge')"
              :dispH="270"
            />
          </div>
          <div style="width: 370px; padding-top: 0px; margin-top: 36px" class="border-bottom-thin">
            <el-form label-position="left" label-width="200px;">
              <el-form-item :label="$t('langcfg.txtRecommendedLevel') + ':'">
                <el-radio-group v-model="level" @change="radioChange" fill="#409EFF">
                  <el-radio label="1">{{ $t("langcfg.txtNormal") }}</el-radio>
                  <br />
                  <el-radio label="2">{{ $t("langcfg.txtMild") }}</el-radio>
                  <br />
                  <el-radio label="3">{{ $t("langcfg.txtModerate") }}</el-radio>
                  <br />
                  <el-radio label="4">{{ $t("langcfg.txtSevere") }}</el-radio>
                  <br />
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { Message, Size, SubPageSize } from "../../mixins";
import TrendChart from "./basic/TrendChart";
import ImageBox from "../../common/components/ImageBox";
import ImageItem from "./basic/ImageItem";
import ImageList from "./basic/ImageList";
import EVENTS from "../../bus";
import { cloneObj, getImageUrl, isDefined } from "../../shared/utils";
let img1px = new Image();
img1px.onload = () => {};
export default {
  name: "EyelidEdge",
  mixins: [Message, Size, SubPageSize],
  data() {
    return {
      currentid: 0,
      level: 1,
      note: "",
      dispPhoto: {},
      eyelidEdgeData: {},
      graphUnit: "mm",
      currPaper: undefined,
      graphMode: "Select",
      graphColor: "#00ff00",
      currPage: "eyelidedge",
      listImg: { up: {}, down: {} },
      curRecord: {},
      isIT: false
    };
  },
  props: {
    record: Object,
    currentEye: {
      type: String,
      default: "OD"
    }
  },
  mounted() {
    this.init(this.record);
    this.$bus.$emit(EVENTS.uploadingThirdyParty, "eyelidedge");
    this.isIT = window.settings.language === "it";
  },
  updated() {
    this.isIT = window.settings.language === "it";
  },
  components: {
    TrendChart,
    ImageItem,
    ImageList,
    ImageBox
  },
  methods: {
    handleClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.note, (value) => {
        self.note = value;
      });
    },
    init(record) {
      this.curRecord = cloneObj(record);

      this.eyelidEdgeData[this.currentEye] =
        this.curRecord.content[`data${this.currentEye}`]["eyelidedge"];

      this.showInterFaceOrToCamera();
    },
    showInterFaceOrToCamera() {
      if (
        isDefined(this.eyelidEdgeData[this.currentEye].up) &&
        this.eyelidEdgeData[this.currentEye].up.photos.length > 0 &&
        isDefined(this.eyelidEdgeData[this.currentEye].down) &&
        this.eyelidEdgeData[this.currentEye].down.photos.length > 0
      ) {
        // 都存在
        this.listImg.up = this.dispPhoto = this.getListImg(
          this.eyelidEdgeData[this.currentEye].up.photos
        );
        this.listImg.down = this.getListImg(this.eyelidEdgeData[this.currentEye].down.photos);
        // this.level = this.eyelidEdgeData[this.currentEye].up.level
        this.note = this.eyelidEdgeData[this.currentEye].note;
        // this.currentid = 0
        this.selectItem(this.currentid);
      } else if (
        isDefined(this.eyelidEdgeData[this.currentEye].up) &&
        this.eyelidEdgeData[this.currentEye].up.photos.length > 0
      ) {
        // 只拍了上睑缘
        this.listImg.up = this.dispPhoto = this.getListImg(
          this.eyelidEdgeData[this.currentEye].up.photos
        );
        this.level = this.eyelidEdgeData[this.currentEye].up.level;
        this.note = this.eyelidEdgeData[this.currentEye].note;
        this.listImg.down = this.dispPhoto = "";
        this.currentid = 0;
        this.selectItem(0);
      } else if (
        isDefined(this.eyelidEdgeData[this.currentEye].down) &&
        this.eyelidEdgeData[this.currentEye].down.photos.length > 0
      ) {
        // 只拍了下睑缘
        this.listImg.down = this.dispPhoto = this.getListImg(
          this.eyelidEdgeData[this.currentEye].down.photos
        );
        this.level = this.eyelidEdgeData[this.currentEye].down.level;
        this.note = this.eyelidEdgeData[this.currentEye].note;
        this.listImg.up = this.dispPhoto = "";
        this.currentid = 1;
        this.selectItem(1);
      }

      // radio切换bug
      if (this.currentid === 0) {
        if (this.eyelidEdgeData[this.currentEye].up) {
          this.level = this.eyelidEdgeData[this.currentEye].up.level;
        } else {
        }
      }
      this.direction = this.dispPhoto.direction;
      this.level = this.level === -1 ? 1 : this.level;
    },
    selectItem(id) {
      this.currentid = id;
      if (id === 0) {
        if (this.eyelidEdgeData[this.currentEye].up) {
          this.dispPhoto = this.getListImg(this.eyelidEdgeData[this.currentEye].up.photos);
          this.level = this.eyelidEdgeData[this.currentEye].up.level;
          this.level = this.level === -1 ? 1 : this.level;
        } else if (this.eyelidEdgeData[this.currentEye].up === undefined) {
          this.dispPhoto = "";
        }
      } else if (id === 1) {
        if (this.eyelidEdgeData[this.currentEye].down) {
          this.dispPhoto = this.getListImg(this.eyelidEdgeData[this.currentEye].down.photos);
          this.level = this.eyelidEdgeData[this.currentEye].down.level;
          this.level = this.level === -1 ? 1 : this.level;
        } else if (this.eyelidEdgeData[this.currentEye].down === undefined) {
          this.dispPhoto = "";
        }
      }
      this.direction = this.dispPhoto.direction;
    },
    getImageURL: function (file) {
      return getImageUrl((file || {}).filename, window.server, window.token);
    },
    getMarking: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.marking;
      } else {
        return undefined;
      }
    },
    getInfo: function () {
      if (this.dispPhoto) {
        let info = {
          eyeType: "os",
          magnification: "16"
        };
        return info;
      } else {
        return undefined;
      }
    },
    getProc: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.imgproc;
      } else {
        return undefined;
      }
    },
    getEyeType: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.eyetype;
      } else {
        return undefined;
      }
    },
    update(marking) {
      this.curRecord.content[`data${this.currentEye}`]["eyelidedge"].note = this.note;
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
    },
    onImageFocus: function (dispid, paper) {
      this.currPaper = paper;
    },
    selectPaper: function (g, paper) {
      this.graph = g;
      this.currPaper = paper;
    },
    getListImg: function (obj) {
      for (let id in obj) {
        if (obj[id].imagelabel === "original") {
          return obj[id];
        }
      }
    },
    changeNote(e) {
      // 失焦之后就将现有的文字赋值给记录并上传
      // this.eyelidEdgeData[this.currentEye].note = this.note
      this.curRecord.content[`data${this.currentEye}`]["eyelidedge"].note = this.note;
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
    },
    retake: function (val) {
      this.$emit("show-capture", "eyelidedge", val);
    },
    radioChange: function () {
      if (this.currentid === 0) {
        this.eyelidEdgeData[this.currentEye].up.level = this.level;
        this.curRecord.content[`data${this.currentEye}`]["eyelidedge"]["up"].level = this.level;
      } else if (this.currentid === 1) {
        this.eyelidEdgeData[this.currentEye].down.level = this.level;
        this.curRecord.content[`data${this.currentEye}`]["eyelidedge"]["down"].level = this.level;
      }
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
      if (isDefined(this.record.content[`data${this.currentEye}`]["eyelidedge"])) {
        if (
          isDefined(this.record.content[`data${this.currentEye}`]["eyelidedge"]["up"]) &&
          isDefined(this.record.content[`data${this.currentEye}`]["eyelidedge"]["up"].uploaded)
        ) {
          this.$bus.$emit(EVENTS.uploadingThirdyParty, "eyelidedge", this.curRecord, true);
          return;
        }
        if (
          isDefined(this.record.content[`data${this.currentEye}`]["eyelidedge"]["down"]) &&
          isDefined(this.record.content[`data${this.currentEye}`]["eyelidedge"]["down"].uploaded)
        ) {
          this.$bus.$emit(EVENTS.uploadingThirdyParty, "eyelidedge", this.curRecord, true);
          return;
        }
      }
      // 合并数据，上传等级
    }
  },
  watch: {
    currentEye: {
      handler(newType) {
        this.currentEye = newType;
        this.init(this.record);
      },
      deep: true
    },
    note: function (val) {
      this.curRecord.content[`data${this.currentEye}`]["eyelidedge"].note = val;
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
    }
  },
  dispPhoto: {
    handler(newVal) {},
    immediate: true,
    deep: true
  },
  record: {
    handler(newRecord) {
      this.init(newRecord);
    },
    immediate: true,
    deep: true
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
label {
  font-size: 23px;
}
.before::after {
  content: "\00A0\00A0\00A0\00A0";
}
.input-result {
  font-size: 23px;
  width: 95%;
  padding: 4px 10px;
  border-radius: 5px;
  border: none;
  outline: none;
}
.el-radio {
  margin-bottom: 20px;
}
.btn-oprator {
  border: 1px solid #ccc;
  height: 100px;
}
.retakeStyle {
  height: 80px;
  box-sizing: border-box;
  padding: 0 20px;
}
/deep/.el-dialog {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
}
/deep/ .el-dialog__body {
  padding: 0 10px;
}
/deep/ .el-dialog__header {
  padding: 0;
}
#virtualKeyboard.ZH div.kbButton span {
  font-size: 18t !important;
}
/deep/ .el-textarea textarea {
  font-size: 32px;
  // height:174px
}
/deep/ .el-form-item__label {
  font-size: 30px;
}
/deep/ .el-form-item__content {
  padding-top: 5px;
}
/deep/ .el-radio__label {
  padding-left: 20px;
  vertical-align: -2px;
}
/deep/ .el-radio-group {
  padding-left: 24px;
}
/deep/.el-textarea__inner {
  line-height: inherit !important;
  padding: 2px 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/EyeLidEdge.vue